import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IAlertList } from '../types/IAlert';

export interface IGetUserAlertListParams {
}

export interface IGetUserAlertListResult extends IAlertList {
}

export class GetUserAlertListRequest extends Request<IGetUserAlertListParams, IGetUserAlertListResult> {
  constructor(params: IGetUserAlertListParams = {}) {
    super('getUserAlertList', params);
  }
}
